import React from 'react'

export const IconCheck = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 26" fill='currentColor' {...props}>
        <path fill-rule="evenodd" d="M548.78 1040.2c-1.6-1.63-4.18-1.63-5.78 0l-14.44 14.72 -3.61-3.68c-1.6-1.62-4.19-1.62-5.78 0 -1.6 1.63-1.6 4.27 0 5.89l6.49 6.63c1.59 1.63 4.18 1.63 5.77 0l17.32-17.67c1.59-1.63 1.59-4.27 0-5.89" transform="translate(-518-1039)"></path>
    </svg>
  )
}
